import React, { useState, useEffect, useMemo } from "react";
import LoaderStyleOne from '../../../components/LoaderStyleOne';
import MUIDataTable from "mui-datatables";
import {
  Box,
  Grid,
  //Button,
  Typography,
  TextField,
  IconButton,
  Link,
  //Select,
  TableCell,
  Tabs,
  Tab,
} from "@mui/material";
import { getData, postData } from "../../../ServerRequest";
import LandscapeIcon from "@mui/icons-material/Landscape";
//import TrendingDownIcon from "@mui/icons-material/TrendingDown";
//import TrendingUpIcon from "@mui/icons-material/TrendingUp";
//import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import UnarchiveOutlinedIcon from "@mui/icons-material/UnarchiveOutlined";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';
import Paper from '@mui/material/Paper';
//import { makeStyles } from "@mui/styles";
import { ThemeProvider, createTheme } from "@mui/material/styles";

const theme = createTheme({
  components: {
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontFamily: "Inter",
          fontWeight: 600,
          backgroundColor: "#FAFAFB",
          textAlign: "center",
          cursor: "pointer",
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "#FAFAFB",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: "#F9F9F9", // Alternate row color
          },
        },
      },
    },
    MuiTableSortLabel: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          "&:hover": {
            color: "#000",
          },
          "&.Mui-active": {
            color: "#000", // Correctly override the active state
          },
        },
        icon: {
          color: "#000 !important", // Ensure the sort icon color is overridden
        },
      },
    },
  },
});

const renderSortIcon = (columnMeta, sortOrder) => {
  if (sortOrder && sortOrder.index === columnMeta.index) {
    return sortOrder.direction === "asc" ? (
      <ArrowUpwardIcon style={{ fontSize: 16, marginLeft: 4, color: "#000" }} />
    ) : (
      <ArrowDownwardIcon
        style={{ fontSize: 16, marginLeft: 4, color: "#000" }}
      />
    );
  }
  return (
    <ArrowUpwardIcon style={{ fontSize: 16, marginLeft: 4, color: "#ccc" }} />
  );
};

const getCustomHeadRender = (columnMeta, handleToggleColumn, sortOrder) => (
  <TableCell
    key={columnMeta.index}
    style={{
      fontFamily: "Inter",
      fontWeight: 600,
      backgroundColor: "#FAFAFB",
      textAlign: "center",
      cursor: "pointer",
    }}
    onClick={() => handleToggleColumn(columnMeta.index)}
  >
    {columnMeta.label}
    {renderSortIcon(columnMeta, sortOrder)}
  </TableCell>
);

export default function ProductDetails() {
  //const classes = useStyles();
  const [addedProducts, setAddedProductsData] = useState([]);
  const [liveProducts, setLiveProductsData] = useState([]);
  const [archivedProducts, setArchivedProductsData] = useState([]);
  const [deletedProducts, setDeletedProductsData] = useState([]);
  const [editedProducts, setEditedProductsData] = useState([]);
  const [productStatus, setProductStatus] = useState("live");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedTab, setSelectedTab] = useState(0);
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 10,
    total: 0,
  });
  const [loading, setLoading] = useState(true);
  const [counts, setCounts] = useState({
    addedProductCount: 0,
    liveProductCount: 0,
    archivedProductCount: 0,
    deletedProductCount: 0,
    editedProductCount: 0,
  });
  const [collectionsModalOpen, setCollectionsModalOpen] = useState(false);
  const [collectionsModalData, setCollectionsModalData] = useState([]);

  const fetchProducts = async (page = 1) => {
    setLoading(true);
    try {
      const resData = await getData(
        `/api/product/all?ps_product_status=${productStatus}&page=${page}&per_page=${pagination.per_page}`
      );
      console.log("API Response:", resData); // Debug response
      const {
        products = [],
        pagination: pag = {
          total_product: 0,
          total: 0,
          num_pages: 1,
          current_page: 1,
          per_page: 10,
        },
      } = resData.data;

      setAddedProductsData(resData["data"]["added_products"]);
      setLiveProductsData(resData["data"]["live_products"]);
      setArchivedProductsData(resData["data"]["archived_products"]);
      setDeletedProductsData(resData["data"]["deleted_products"]);
      setEditedProductsData(resData["data"]["edited_products"] || []);
      setPagination(pag);
      setCounts({
        addedProductCount: resData["data"]["added_products_count"] || 0,
        liveProductCount: resData["data"]["live_products_count"] || 0,
        archivedProductCount: resData["data"]["archived_products_count"] || 0,
        deletedProductCount: resData["data"]["deleted_products_count"] || 0,
        editedProductCount: resData["data"]["edited_products_count"] || 0,
      });
    } catch (error) {
      console.error("Error fetching products:", error);
      setPagination({ total: 0, num_pages: 1, current_page: 1, per_page: 10 });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, [productStatus]);

  const addedColumns = useMemo(
    () => [
      {
        name: "ps_product_productcode",
        label: "Product Code",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center", fontWeight: 600 },
          }),
        },
      },
      {
        name: "ps_product_netqty",
        label: "Inventory in Mtr",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
        },
      },
      {
        name: "ps_product_createdttime",
        label: "Date Created",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
          customBodyRender: (value) => (value ? value.split("T")[0] : ""),
        },
      },
      {
        name: "updated_on",
        label: "Added/Updated On",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
          customBodyRender: (value) => (value ? value.split("T")[0] : ""),
        },
      },
      {
        name: "ps_product_cat",
        label: "Fabric Category",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
        },
      },
      {
        name: "ps_product_productcode",
        label: "Action",
        options: {
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <TableCell
              key={columnMeta.index}
              style={{
                fontFamily: "Inter",
                fontWeight: 600,
                backgroundColor: "#FAFAFB",
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              {columnMeta.label}
            </TableCell>
          ),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
          customBodyRender: (value, tableMeta) => (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Link
                style={{
                  color: "black",
                  fontWeight: "bold",
                  textDecoration: "none",
                }}
                href={
                  "/admin/products/productDetail/productDetail?product_id=" +
                  value
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconButton>
                  <EditOutlinedIcon
                    style={{ color: "black", width: "20px", height: "20px" }}
                  />
                </IconButton>
              </Link>
            </div>
          ),
        },
      },
    ],
    [addedProducts]
  );

  const liveColumns = useMemo(
    () => [
      {
        name: "ps_product_productimg",
        label: "Image",
        options: {
          filter: true,
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <TableCell
              key={columnMeta.index}
              style={{
                fontWeight: "bold",
                backgroundColor: "#FAFAFB",
                textAlign: "center",
              }}
            >
              {columnMeta.label}
            </TableCell>
          ),
          customBodyRender: (value, tableMeta, updateValue) => {
            // Extract the first image from the comma-separated string
            const firstImage = value ? value.split(",")[0].trim() : null;
            const baseURL =
              "https://www.ambikacc.com/product-profile-temp/medium-";

            return (
              <div
                style={{
                  width: 80,
                  height: 53,
                  backgroundColor: "#F3F4F6",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "0px",
                  border: "1px solid #F3F4F6",
                  overflow: "hidden",
                  textAlign: "center",
                  margin: "auto",
                }}
              >
                {firstImage ? (
                  <img
                    src={`${baseURL}${firstImage}`} // Construct the full image URL if needed
                    alt="img"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <LandscapeIcon style={{ color: "#BCC1CA", fontSize: 30 }} />
                )}
              </div>
            );
          },
        },
      },
      {
        name: "ps_product_productcode",
        label: "Product Title",
        options: {
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center", fontWeight: 600 },
          }),
        },
      },
      {
        name: "ps_product_netqty",
        label: "Inventory in Mtr",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
        },
      },
      {
        name: "updated_on",
        label: "Date Updated",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
          customBodyRender: (value) => (value ? value.split("T")[0] : ""),
        },
      },
      {
        name: "collection_added",
        label: "Collections Added",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
          customBodyRender: (value, tableMeta) => {
            const row = liveProducts[tableMeta.rowIndex];
            const collectionsCount = row && Array.isArray(row.collections) ? row.collections.length : 0;
            return (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span>{collectionsCount}</span>
                {collectionsCount > 0 && (
                  <IconButton sx={{ color: "#000000"}} size="small" onClick={() => handleOpenCollectionsModal(row.collections)}>
                    <KeyboardArrowDownIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                )}
              </div>
            );
          },
        },
      },
      {
        name: "ps_product_updatedtime",
        label: "Updated By",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
          customBodyRender: (value, tableMeta) => {
            if (Array.isArray(value)) {
              return (
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "5px",
                    justifyContent: "center",
                  }}
                >
                  {value.map((product) => (
                    <div
                      key={product.id}
                      style={{
                        padding: "5px 10px",
                        backgroundColor: "#F3F4F6",
                        borderRadius: "15px",
                        fontSize: "12px",
                        color: "#323842",
                        textAlign: "center",
                      }}
                    >
                      {product.updatedby_name}
                    </div>
                  ))}
                </div>
              );
            }
            return value;
          },
        },
      },
      {
        name: "ps_product_productcode", // Use product code as the column name
        label: "Action",
        options: {
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <TableCell
              key={columnMeta.index}
              style={{
                fontFamily: "Inter",
                fontWeight: 600,
                backgroundColor: "#FAFAFB",
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              {columnMeta.label}
            </TableCell>
          ),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
          customBodyRender: (value, tableMeta) => {
            // Find the row in liveProducts by product code
            const row = liveProducts.find(
              (item) => item.ps_product_productcode === value
            );
            return (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Link
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    textDecoration: "none",
                  }}
                  href={
                    "/admin/products/productDetail/productDetail?product_id=" +
                    value
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <IconButton>
                    <EditOutlinedIcon
                      style={{ color: "black", width: "20px", height: "20px" }}
                    />
                  </IconButton>
                </Link>
                {selectedTab === 0 && (
                  <>
                    <IconButton
                      style={{ color: "black", marginLeft: 15 }}
                      onClick={async () => {
                        if (row) await handleSaveArchive(row);
                      }}
                    >
                      <ArchiveOutlinedIcon
                        style={{ color: "black", width: "20px", height: "20px" }}
                      />
                    </IconButton>
                    <IconButton
                      style={{ color: "black", marginLeft: 15 }}
                      onClick={async () => {
                        if (row) await handleSaveDelete(row);
                      }}
                    >
                      <DeleteOutlinedIcon
                        style={{ color: "black", width: "20px", height: "20px" }}
                      />
                    </IconButton>
                  </>
                )}
              </div>
            );
          },
        },
      },
    ],
    [liveProducts, selectedTab]
  );

  const archivedColumns = useMemo(
    () => [
      // Define columns specific to the "Archived" tab
      {
        name: "ps_product_productimg",
        label: "Image",
        options: {
          filter: true,
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <TableCell
              key={columnMeta.index}
              style={{
                fontWeight: "bold",
                backgroundColor: "#FAFAFB",
                textAlign: "center",
              }}
            >
              {columnMeta.label}
            </TableCell>
          ),
          customBodyRender: (value, tableMeta, updateValue) => {
            // Extract the first image from the comma-separated string
            const firstImage = value ? value.split(",")[0].trim() : null;
            const baseURL =
              "https://www.ambikacc.com/product-profile-temp/medium-";

            return (
              <div
                style={{
                  width: 80,
                  height: 53,
                  backgroundColor: "#F3F4F6",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "0px",
                  border: "1px solid #F3F4F6",
                  overflow: "hidden",
                  textAlign: "center",
                  margin: "auto",
                }}
              >
                {firstImage ? (
                  <img
                    src={`${baseURL}${firstImage}`} // Construct the full image URL
                    alt="img"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <LandscapeIcon style={{ color: "#BCC1CA", fontSize: 30 }} />
                )}
              </div>
            );
          },
        },
      },
      {
        name: "ps_product_productcode",
        label: "Product Title",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center", fontWeight: 600 },
          }),
        },
      },
      {
        name: "ps_product_netqty",
        label: "Inventory in Mtr",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
        },
      },
      {
        name: "ps_product_updatedtime",
        label: "Date Updated",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
          customBodyRender: (value) => (value ? value.split("T")[0] : ""),
        },
      },
      {
        name: "collection_added",
        label: "Collections Added",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
          customBodyRender: (value, tableMeta) => {
            const row = archivedProducts[tableMeta.rowIndex];
            const collectionsCount = row && Array.isArray(row.collections) ? row.collections.length : 0;
            return (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span>{collectionsCount}</span>
                {collectionsCount > 0 && (
                  <IconButton sx={{ color: "#000000"}} size="small" onClick={() => handleOpenCollectionsModal(row.collections)}>
                    <KeyboardArrowDownIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                )}
              </div>
            );
          },
        },
      },
      {
        name: "ps_product_updatedtime",
        label: "Updated By",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
          customBodyRender: (value, tableMeta) => {
            if (Array.isArray(value)) {
              return (
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "5px",
                    justifyContent: "center",
                  }}
                >
                  {value.map((product) => (
                    <div
                      key={product.id}
                      style={{
                        padding: "5px 10px",
                        backgroundColor: "#F3F4F6",
                        borderRadius: "15px",
                        fontSize: "12px",
                        color: "#323842",
                        textAlign: "center",
                      }}
                    >
                      {product.updatedby_name}
                    </div>
                  ))}
                </div>
              );
            }
            return value;
          },
        },
      },
      {
        name: "id",
        label: "Action",
        options: {
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <TableCell
              key={columnMeta.index}
              style={{
                fontFamily: "Inter",
                fontWeight: 600,
                backgroundColor: "#FAFAFB",
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              {columnMeta.label}
            </TableCell>
          ),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
          customBodyRender: (value, tableMeta) => {
            // Find the row in archivedProducts by id
            const row = archivedProducts.find((item) => item.id === value);
            return (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <IconButton
                  onClick={async () => {
                    if (row) await handleSaveRetrieve(row);
                  }}
                >
                  <UnarchiveOutlinedIcon
                    style={{ color: "black", width: "20px", height: "20px" }}
                  />
                </IconButton>
              </div>
            );
          },
        },
      },
    ],
    [archivedProducts]
  );

  const deletedColumns = useMemo(
    () => [
      // Define columns specific to the "Deleted" tab
      {
        name: "ps_product_productimg",
        label: "Image",
        options: {
          filter: true,
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <TableCell
              key={columnMeta.index}
              style={{
                fontWeight: "bold",
                backgroundColor: "#FAFAFB",
                textAlign: "center",
              }}
            >
              {columnMeta.label}
            </TableCell>
          ),
          customBodyRender: (value, tableMeta, updateValue) => {
            // Extract the first image from the comma-separated string
            const firstImage = value ? value.split(",")[0].trim() : null;
            const baseURL =
              "https://www.ambikacc.com/product-profile-temp/medium-";

            return (
              <div
                style={{
                  width: 80,
                  height: 53,
                  backgroundColor: "#F3F4F6",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "0px",
                  border: "1px solid #F3F4F6",
                  overflow: "hidden",
                  textAlign: "center",
                  margin: "auto",
                }}
              >
                {firstImage ? (
                  <img
                    src={`${baseURL}${firstImage}`} // Construct the full image URL if needed
                    alt="img"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <LandscapeIcon style={{ color: "#BCC1CA", fontSize: 30 }} />
                )}
              </div>
            );
          },
        },
      },
      {
        name: "ps_product_productcode",
        label: "Product Title",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center", fontWeight: 600 },
          }),
        },
      },
      {
        name: "ps_product_netqty",
        label: "Inventory in Mtr",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
        },
      },
      {
        name: "ps_product_updatedtime",
        label: "Date Updated",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
          customBodyRender: (value) => (value ? value.split("T")[0] : ""),
        },
      },
      {
        name: "collection_added",
        label: "Collections Added",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
          customBodyRender: (value, tableMeta) => {
            const row = deletedProducts[tableMeta.rowIndex];
            const collectionsCount = row && Array.isArray(row.collections) ? row.collections.length : 0;
            return (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span>{collectionsCount}</span>
                {collectionsCount > 0 && (
                  <IconButton sx={{ color: "#000000"}} size="small" onClick={() => handleOpenCollectionsModal(row.collections)}>
                    <KeyboardArrowDownIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                )}
              </div>
            );
          },
        },
      },
      {
        name: "ps_product_updatedtime",
        label: "Updated By",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
          customBodyRender: (value, tableMeta) => {
            if (Array.isArray(value)) {
              return (
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "5px",
                    justifyContent: "center",
                  }}
                >
                  {value.map((product) => (
                    <div
                      key={product.id}
                      style={{
                        padding: "5px 10px",
                        backgroundColor: "#F3F4F6",
                        borderRadius: "15px",
                        fontSize: "12px",
                        color: "#323842",
                        textAlign: "center",
                      }}
                    >
                      {product.updatedby_name}
                    </div>
                  ))}
                </div>
              );
            }
            return value;
          },
        },
      },
      {
        name: "ps_product_deleted_date",
        label: "Deleted Date",
        options: {
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <TableCell
              key={columnMeta.index}
              style={{
                fontFamily: "Inter",
                fontWeight: 600,
                backgroundColor: "#FAFAFB",
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              {columnMeta.label}
            </TableCell>
          ),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
          customBodyRender: (value) => (value ? value.split("T")[0] : ""),
        },
      },
      // Add more columns as needed
    ],
    []
  );

  const editedColumns = useMemo(
    () => [
      {
        name: "ps_product_productcode",
        label: "Product Code",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center", fontWeight: 600 },
          }),
        },
      },
      {
        name: "ps_product_netqty",
        label: "Inventory in Mtr",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
        },
      },
      {
        name: "ps_product_createdttime",
        label: "Date Created",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
          customBodyRender: (value) => (value ? value.split("T")[0] : ""),
        },
      },
      {
        name: "updated_on",
        label: "Added/Updated On",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
          customBodyRender: (value) => (value ? value.split("T")[0] : ""),
        },
      },
      {
        name: "ps_product_cat",
        label: "Fabric Category",
        options: {
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) =>
            getCustomHeadRender(columnMeta, handleToggleColumn, sortOrder),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
        },
      },
      {
        name: "ps_product_productcode",
        label: "Action",
        options: {
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <TableCell
              key={columnMeta.index}
              style={{
                fontFamily: "Inter",
                fontWeight: 600,
                backgroundColor: "#FAFAFB",
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              {columnMeta.label}
            </TableCell>
          ),
          setCellProps: () => ({
            style: { textAlign: "center" },
          }),
          customBodyRender: (value, tableMeta) => (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Link
                style={{
                  color: "black",
                  fontWeight: "bold",
                  textDecoration: "none",
                }}
                href={
                  "/admin/products/productDetail/productDetail?product_id=" +
                  value
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconButton>
                  <EditOutlinedIcon
                    style={{ color: "black", width: "20px", height: "20px" }}
                  />
                </IconButton>
              </Link>
            </div>
          ),
        },
      },
    ],
    []
  );

  const columns = useMemo(() => {
    switch (selectedTab) {
      case 0:
        return liveColumns;
      case 1:
        return addedColumns;
      case 2:
        return editedColumns;
      case 3:
        return archivedColumns;
      case 4:
        return deletedColumns;
      default:
        return liveColumns;
    }
  }, [
    selectedTab,
    addedColumns,
    liveColumns,
    archivedColumns,
    deletedColumns,
    editedColumns,
  ]);

  const filteredData = useMemo(() => {
    let data;
    if (selectedTab === 0) {
      data = liveProducts;
    } else if (selectedTab === 1) {
      data = addedProducts;
    } else if (selectedTab === 2) {
      data = editedProducts;
    } else if (selectedTab === 3) {
      data = archivedProducts;
    } else if (selectedTab === 4) {
      data = deletedProducts;
    } else {
      data = editedProducts;
    }
    if (!Array.isArray(data)) return [];
    if (searchQuery) {
      const searchTerms = searchQuery.toLowerCase().split(" ");
      console.log("Filtering data with search terms:", searchTerms);
      console.log("Original data length:", data);
      
      data = data.filter((row) =>
        Object.values(row || {}).some((value) =>
          typeof value === "object"
            ? Object.values(value || {}).some((subValue) =>
                subValue
                  ?.toString()
                  .toLowerCase()
                  .includes(searchQuery.toLowerCase())
              )
            : value
                ?.toString()
                .toLowerCase()
                .includes(searchQuery.toLowerCase())
        )
      );
    }
    return [...data].sort((a, b) => {
      if (a.ps_product_createdttime && b.ps_product_createdttime) {
        return (
          new Date(b.ps_product_createdttime) -
          new Date(a.ps_product_createdttime)
        );
      }
      if (a.id && b.id) {
        return b.id - a.id;
      }
      return 0;
    });
  }, [
    selectedTab,
    editedProducts,
    addedProducts,
    liveProducts,
    archivedProducts,
    deletedProducts,
    searchQuery,
  ]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    setProductStatus(
      newValue === 0
        ? "live"
        : newValue === 1
        ? "added"
        : newValue === 2
        ? "edited"
        : newValue === 3
        ? "archived"
        : "deleted"
    );
  };

  const handleOpenCollectionsModal = (collections) => {
    setCollectionsModalData(collections || []);
    setCollectionsModalOpen(true);
  };
  const handleCloseCollectionsModal = () => {
    setCollectionsModalOpen(false);
    setCollectionsModalData([]);
  };

  // Archive a product (move from live to archived)
  const handleSaveArchive = async (row) => {
    try {
      const productData = {
        'ps_product_ID': row.ps_product_ID || row.ps_product_productcode || "",
        'ps_product_status': "archived",
      };
      console.log("Archive: Sending productData", productData);
      const res = await postData("/api/product/all", productData);
      console.log("Archive: Received response", res);
      if (res["data"]["code"] === "200") {
        const updatedRow = res.data.updated_product || {
          ...row,
          ps_product_status: "archived",
        };
        setLiveProductsData((prev) =>
          prev.filter(
            (item) =>
              (item.ps_product_ID || item.id) !== (row.ps_product_ID || row.id)
          )
        );
        setArchivedProductsData((prev) => [updatedRow, ...prev]);
        setCounts((prevCounts) => ({
          ...prevCounts,
          liveProductCount: prevCounts.liveProductCount - 1,
          archivedProductCount: prevCounts.archivedProductCount + 1,
        }));
      } else {
        alert("Archive failed");
        console.log("Archive: Failed response", res);
      }
    } catch (error) {
      console.error("Error archiving data:", error);
    }
  };

  // Retrieve a product from archive (move from archived to live)
  const handleSaveRetrieve = async (row) => {
    try {
      const productData = {
        'ps_product_ID': row.ps_product_ID || row.ps_product_productcode || "",
        'ps_product_status': "live",
      };
      console.log("Retrieve: Sending productData", productData);
      const res = await postData("/api/product/all", productData);
      console.log("Retrieve: Received response", res);
      if (res["data"]["code"] === "200") {
        const updatedRow = res.data.updated_product || {
          ...row,
          ps_product_status: "live",
        };
        setArchivedProductsData((prev) =>
          prev.filter(
            (item) =>
              (item.ps_product_ID || item.id) !== (row.ps_product_ID || row.id)
          )
        );
        setLiveProductsData((prev) => [
          updatedRow,
          ...prev.filter(
            (item) =>
              (item.ps_product_ID || item.id) !== (row.ps_product_ID || row.id)
          ),
        ]);
        setCounts((prevCounts) => ({
          ...prevCounts,
          archivedProductCount: prevCounts.archivedProductCount - 1,
          liveProductCount: prevCounts.liveProductCount + 1,
        }));
      } else {
        alert("Retrieve failed");
        console.log("Retrieve: Failed response", res);
      }
    } catch (error) {
      console.error("Error retrieving data:", error);
    }
  };

  // Delete a product (move from live to deleted)
  const handleSaveDelete = async (row) => {
    try {
      const productData = {
        'ps_product_ID': row.ps_product_ID || row.ps_product_productcode || "",
        'ps_product_status': "deleted",
      };
      console.log("Delete: Sending productData", productData);
      const res = await postData("/api/product/all", productData);
      console.log("Delete: Received response", res);
      if (res["data"]["code"] === "200") {
        const updatedRow = res.data.updated_product || {
          ...row,
          ps_product_status: "deleted",
        };
        setLiveProductsData((prev) =>
          prev.filter(
            (item) =>
              (item.ps_product_ID || item.id) !== (row.ps_product_ID || row.id)
          )
        );
        setDeletedProductsData((prev) => [updatedRow, ...prev]);
        setCounts((prevCounts) => ({
          ...prevCounts,
          liveProductCount: prevCounts.liveProductCount - 1,
          deletedProductCount: prevCounts.deletedProductCount + 1,
        }));
      } else {
        alert("Delete failed");
        console.log("Delete: Failed response", res);
      }
    } catch (error) {
      console.error("Error deleting data:", error);
    }
  };

  const options = {
    filterType: "checkbox",
    responsive: "standard",
    print: false, // Disable print
    download: false, // Disable download
    columns: false, // Disable column visibility
    viewColumns: false, // Disable view columns
    filter: false,
    search: false,
    sort: true,
    selectableRows: "none", // Disable row selection
    classes: {
      tableHeadCell: {
        fontFamily: "Inter",
        fontWeight: 600,
        backgroundColor: "#FAFAFB",
        textAlign: "center",
        cursor: "pointer",
        color: "#333",
        borderBottom: "2px solid #E0E0E0",
      },
    },
    // serverSide: false, // Enable server-side pagination
    // count: pagination?.total_product || 0, // Set the total count of items
    // page: pagination?.current_page - 1, // MUI uses zero-based indexing for pages
    // rowsPerPage: pagination?.per_page,
    // onChangePage: (currentPage) => {
    //     fetchProducts(currentPage + 1); // Convert zero-based index to one-based index
    // },
    // onChangeRowsPerPage: (rowsPerPage) => {
    //     setPagination((prev) => ({ ...prev, per_page: rowsPerPage }));
    //     fetchProducts(1); // Reset to the first page when per_page changes
    // },
    textLabels: {
      body: {
        noMatch: loading ? "Loading..." : "Sorry, no matching records found",
      },
    },
  };

  return (
    <Box sx={{ width: "95%", paddingLeft: 3, mb: 5 }}>
      <Grid container sx={{ flex: 1, height: "100%" }}>
        {/* Product Update Panel Section */}
        <Grid
          container
          direction={{ xs: "column", md: "row" }}
          alignItems={{ xs: "stretch", md: "center" }}
          justifyContent="space-between"
          spacing={2}
          sx={{
            p: 0,
            mb: 2,
            flexWrap: { xs: "nowrap", md: "wrap" },
            gap: { xs: 2, md: 0 },
          }}
        >
          <Grid
            item
            xs={12}
            sm={3}
            md={3}
            lg={2}
            sx={{ order: { xs: 1, md: 1 } }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                mt: { xs: 0, md: 2 },
                whiteSpace: "nowrap",
              }}
            >
              Product update panel
            </Typography>
          </Grid>
          <Grid item sx={{ width: "400px", order: { xs: 2, md: 2 } }}>
            <TextField
              sx={{
                width: "377px",
                "& .MuiOutlinedInput-root": {
                  height: "35px",
                  borderRadius: "0px",
                  mt: 2,
                },
              }}
              size="small"
              variant="outlined"
              placeholder="Product, collection by name"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <IconButton
                    position="start"
                    sx={{ ml: "-10px", mr: 1, color: "black" }}
                  >
                    <SearchIcon />
                  </IconButton>
                ),
              }}
            />
          </Grid>
          <Grid item xs sx={{ order: { xs: 3, md: 3 }, minWidth: 0 }}>
            {/* Weekly Data Visualization Legend */}
            {/* {selectedTab !== 0 && selectedTab !== 1 && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "flex-start", md: "flex-end" },
                  width: "100%",
                  mt: { xs: 2, md: 0 },
                }}
              >
                <Box sx={{ width: { xs: "100%", sm: "auto" } }}>
                  <Typography variant="caption" sx={{ display: "block" }}>
                    Weekly data visualization
                  </Typography>
                  <Grid
                    container
                    sx={{
                      display: "flex",
                      gap: 2,
                      backgroundColor: "#DEE1E6",
                      padding: 0.5,
                      pl: 2,
                      width: { xs: "100%", sm: "520px" },
                      margin: { xs: "0 auto", sm: "0" },
                      flexWrap: "wrap",
                    }}
                  >
                    <Grid item xs={12} sm={4} md={4} lg={4}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          flexWrap: "wrap",
                        }}
                      >
                        <TrendingDownIcon color="black" />
                        <Typography variant="body2">Decline in sale</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4} lg={4}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          flexWrap: "wrap",
                        }}
                      >
                        <TrendingUpIcon color="black" />
                        <Typography variant="body2">
                          Increase in sale
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={3}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          flexWrap: "wrap",
                        }}
                      >
                        <PauseCircleOutlineIcon color="black" />
                        <Typography variant="body2">Stagnant item</Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            )} */}
          </Grid> 
        </Grid>
        <Grid
          container
          spacing={2}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            mt: 2,
            mb: 2,
          }}
        >
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <Box sx={{ height: "35px", minWidth: "500px" }}>
              <Tabs
                value={selectedTab}
                onChange={handleTabChange}
                variant="fullWidth"
                sx={{
                  minHeight: "35px",
                  border: "1px solid #F3F4F6",
                  borderRadius: "0px",
                  "& .MuiTabs-flexContainer": {
                    height: "35px",
                  },
                  "& .MuiTab-root": {
                    minHeight: "35px",
                    width: "144px",
                    borderRight: "1px solid #F3F4F6",
                    textTransform: "none",
                    color: "#333",
                    whiteSpace: "nowrap", // Prevent label wrapping
                  },
                  "& .MuiTab-root:last-of-type": {
                    borderRight: "none",
                  },
                  "& .Mui-selected": {
                    color: "#000 !important",
                  },
                  "& .MuiTabs-indicator": {
                    height: "3px !important",
                    backgroundColor: "#9095A0 !important",
                  },
                }}
              >
                <Tab label={`Live (${counts.liveProductCount})`} />
                <Tab label={`Added (${counts.addedProductCount})`} />
                <Tab label={`Edited (${counts.editedProductCount})`} />
                <Tab label={`Archived (${counts.archivedProductCount})`} />
                <Tab label={`Deleted (${counts.deletedProductCount})`} />
              </Tabs>
            </Box>
            {selectedTab === 0 && (
              <Typography variant="caption" sx={{ display: "block" }}>
                {addedProducts?.length || 0} newly added
              </Typography>
            )}
          </Grid>
          {/* <Grid item xs={12} sm={6} md={6} lg={6}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, ml: 'auto' }}>
                    <Select
                        sx={{ width: "250px", height: "35px", borderRadius: "0px" }}
                        size="small"
                        variant="outlined"
                    />
                    <Select
                        sx={{ width: "250px", height: "35px", borderRadius: "0px" }}
                        size="small"
                        variant="outlined"
                        placeholder="Collection Name"
                    />
                </Box>
            </Grid> */}
        </Grid>
        <Grid
          container
          spacing={2}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            mt: 1,
            mb: 4,
          }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {/* Data Table */}
            {/* Data Table */}
            {loading ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
                <LoaderStyleOne />
              </div>
            ) : (
              <Box sx={{ border: "1px solid #F4F3F6" }}>
                <ThemeProvider theme={theme}>
                  <MUIDataTable
                    title={""}
                    data={filteredData}
                    columns={columns}
                    options={{ ...options, elevation: 0 }}
                  />
                </ThemeProvider>
              </Box>
            )}

            {/* {selectedTab === 0 && (
              <div
                style={{
                  textAlign: "end",
                  marginTop: "25px",
                  marginBottom: "40px",
                }}
              >
                <Button
                  sx={{
                    backgroundColor: "#565E6D",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#546e7a" },
                    borderRadius: "0px",
                  }}
                >
                  Send update request
                </Button>
              </div>
            )} */}
          </Grid>
        </Grid>
      </Grid>

      {/* Modal for viewing collections details */}
      <Modal open={collectionsModalOpen} onClose={handleCloseCollectionsModal} sx={{ fontFamily: "Inter" }}>
        <Paper style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', minWidth: 300, padding: 24, borderRadius: 0 }}>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="body1" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              Collection Added : <span style={{ fontWeight: 100, color: '#565E6D' }}>{collectionsModalData.length}</span>
            </Typography>
            <IconButton onClick={handleCloseCollectionsModal} sx={{ mb: 2, color: '#000000' }}>
              <CloseIcon sx={{ fontSize: 15 }} />
            </IconButton>            
          </Box>
          {collectionsModalData.length > 0 ? (
            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 0', fontSize: '13px' }}>
              <thead>
                <tr style={{ background: '#f5f5f5' }}>
                  <th style={{ textAlign: 'center', padding: '8px 24px', borderBottom: '1px solid #ddd' }}>S.No</th>
                  <th style={{ textAlign: 'center', padding: '8px 24px', borderBottom: '1px solid #ddd' }}>Product ID</th>
                  <th style={{ textAlign: 'center', padding: '8px 24px', borderBottom: '1px solid #ddd' }}>Collection Name</th>
                </tr>
              </thead>
              <tbody>
                {collectionsModalData.map((col, idx) => (
                  <tr key={col.id || idx}>
                    <td style={{ padding: '8px 24px', borderBottom: '1px solid #eee', textAlign: 'center' }}>{idx + 1}</td>
                    <td style={{ padding: '8px 24px', borderBottom: '1px solid #eee', textAlign: 'center' }}>{col.product_id}</td>
                    <td style={{ padding: '8px 24px', borderBottom: '1px solid #eee', textAlign: 'center' }}>{col.name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <Typography>No collections found.</Typography>
          )}
        </Paper>
      </Modal>
    </Box>
  );
}
